import {
  freddyTheme,
  Grid,
  GridItem,
  Link,
  Modal,
  ModalBody,
  Typography
} from '@coolblue-development/freddy';
import { ArrowRight, Mail, Phone } from '@coolblue-development/icons';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  open: boolean;
  onClose: () => void;
};

const OMBUDSMAN_INFO = {
  STREET: 'de Meeûssquare 35',
  POSTCODE: '1000',
  CITY: 'Brussel',
  PHONE: '02 547 58 71',
  EMAIL: 'info@ombudsman-insurance.be',
  WEBSITE: 'https://www.ombudsman-insurance.be'
};

export default function OmbudsmanModal({ open, onClose }: Props) {
  const { t } = useTranslation('webshop.productPage.insurance.ombudsmanModal');
  const modalTranslations = useFreddyTranslations('modal');

  return (
    <Modal
      body={
        <ModalBody>
          <Typography variant='h3'>{t('address')}</Typography>
          <Typography m={0}>{OMBUDSMAN_INFO.STREET}</Typography>
          <Typography m={0}>
            {OMBUDSMAN_INFO.POSTCODE} {OMBUDSMAN_INFO.CITY}
          </Typography>
          <Grid mt={300} mb={300} templateColumns='auto 1fr' rowGap={100} columnGap={200}>
            <GridItem>
              <Phone color={freddyTheme.color.icon.base} />
            </GridItem>
            <GridItem>{OMBUDSMAN_INFO.PHONE}</GridItem>
            <GridItem>
              <Mail color={freddyTheme.color.icon.base} />
            </GridItem>
            <GridItem>
              <Link href={`mailto:${OMBUDSMAN_INFO.EMAIL}`} target='_blank'>
                {OMBUDSMAN_INFO.EMAIL}
              </Link>
            </GridItem>
          </Grid>
          <Link
            href={OMBUDSMAN_INFO.WEBSITE}
            target='_blank'
            startIcon={<ArrowRight color={freddyTheme.color.icon.base} />}
          >
            {t('action')}
          </Link>
        </ModalBody>
      }
      open={open}
      onClose={onClose}
      title={t('title')}
      size='medium'
      translations={modalTranslations}
    />
  );
}
